/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { BasicDataDimensions } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataDimensionSearchRequest } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
/**
 * DataAvailabilityControllerApi - axios parameter creator
 */
export const DataAvailabilityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accepts a list of exact (companyId, dataType, reportingPeriod) triples and returns those for which viewable data exists, covering both datasets and data points.
         * @summary Filters the provided data dimension triples to those with viewable data.
         * @param {Array<BasicDataDimensions>} basicDataDimensions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterViewableDimensions: async (basicDataDimensions: Array<BasicDataDimensions>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'basicDataDimensions' is not null or undefined
            assertParamExists('filterViewableDimensions', 'basicDataDimensions', basicDataDimensions)
            const localVarPath = `/data-availability/viewable-dimensions/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(basicDataDimensions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts lists of company IDs, frameworks or data point types, and reporting periods. Returns all viewable data dimensions that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
         * @summary Returns all viewable data dimensions matching the given filters.
         * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchViewableDimensions: async (dataDimensionSearchRequest: DataDimensionSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataDimensionSearchRequest' is not null or undefined
            assertParamExists('searchViewableDimensions', 'dataDimensionSearchRequest', dataDimensionSearchRequest)
            const localVarPath = `/data-availability/viewable-dimensions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataDimensionSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataAvailabilityControllerApi - functional programming interface
 */
export const DataAvailabilityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataAvailabilityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Accepts a list of exact (companyId, dataType, reportingPeriod) triples and returns those for which viewable data exists, covering both datasets and data points.
         * @summary Filters the provided data dimension triples to those with viewable data.
         * @param {Array<BasicDataDimensions>} basicDataDimensions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterViewableDimensions(basicDataDimensions: Array<BasicDataDimensions>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasicDataDimensions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filterViewableDimensions(basicDataDimensions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataAvailabilityControllerApi.filterViewableDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts lists of company IDs, frameworks or data point types, and reporting periods. Returns all viewable data dimensions that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
         * @summary Returns all viewable data dimensions matching the given filters.
         * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchViewableDimensions(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasicDataDimensions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchViewableDimensions(dataDimensionSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataAvailabilityControllerApi.searchViewableDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataAvailabilityControllerApi - factory interface
 */
export const DataAvailabilityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataAvailabilityControllerApiFp(configuration)
    return {
        /**
         * Accepts a list of exact (companyId, dataType, reportingPeriod) triples and returns those for which viewable data exists, covering both datasets and data points.
         * @summary Filters the provided data dimension triples to those with viewable data.
         * @param {Array<BasicDataDimensions>} basicDataDimensions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterViewableDimensions(basicDataDimensions: Array<BasicDataDimensions>, options?: RawAxiosRequestConfig): AxiosPromise<Array<BasicDataDimensions>> {
            return localVarFp.filterViewableDimensions(basicDataDimensions, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts lists of company IDs, frameworks or data point types, and reporting periods. Returns all viewable data dimensions that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
         * @summary Returns all viewable data dimensions matching the given filters.
         * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchViewableDimensions(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BasicDataDimensions>> {
            return localVarFp.searchViewableDimensions(dataDimensionSearchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataAvailabilityControllerApi - interface
 */
export interface DataAvailabilityControllerApiInterface {
    /**
     * Accepts a list of exact (companyId, dataType, reportingPeriod) triples and returns those for which viewable data exists, covering both datasets and data points.
     * @summary Filters the provided data dimension triples to those with viewable data.
     * @param {Array<BasicDataDimensions>} basicDataDimensions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filterViewableDimensions(basicDataDimensions: Array<BasicDataDimensions>, options?: RawAxiosRequestConfig): AxiosPromise<Array<BasicDataDimensions>>;

    /**
     * Accepts lists of company IDs, frameworks or data point types, and reporting periods. Returns all viewable data dimensions that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
     * @summary Returns all viewable data dimensions matching the given filters.
     * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchViewableDimensions(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BasicDataDimensions>>;

}

/**
 * DataAvailabilityControllerApi - object-oriented interface
 */
export class DataAvailabilityControllerApi extends BaseAPI implements DataAvailabilityControllerApiInterface {
    /**
     * Accepts a list of exact (companyId, dataType, reportingPeriod) triples and returns those for which viewable data exists, covering both datasets and data points.
     * @summary Filters the provided data dimension triples to those with viewable data.
     * @param {Array<BasicDataDimensions>} basicDataDimensions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filterViewableDimensions(basicDataDimensions: Array<BasicDataDimensions>, options?: RawAxiosRequestConfig) {
        return DataAvailabilityControllerApiFp(this.configuration).filterViewableDimensions(basicDataDimensions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts lists of company IDs, frameworks or data point types, and reporting periods. Returns all viewable data dimensions that match any combination of the provided filters. An empty list for any field is treated as a wildcard and matches all values for that dimension.
     * @summary Returns all viewable data dimensions matching the given filters.
     * @param {DataDimensionSearchRequest} dataDimensionSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchViewableDimensions(dataDimensionSearchRequest: DataDimensionSearchRequest, options?: RawAxiosRequestConfig) {
        return DataAvailabilityControllerApiFp(this.configuration).searchViewableDimensions(dataDimensionSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

